<script>
import Carregando from '~componentes/Carregando.vue';
import pessoaFisicaServico from '../servico';

export default {
  components: {
    Carregando
  },
  data() {
    return {
      carregando: true,
      carregandoVisualizacao: false,
      assinandoDocumento: false,
      idAssinatura: 0,
      assinatura: {},
      aceiteTermos: false,
      visualizacaoArquivoUrl: '',
      tipoVisualizacaoArquivo: '',
    }
  },
  mounted() {
    this.$root.tituloDaPagina = 'Assinatura Eletrônica - Assinar Documento';
    this.$root.botaoAcaoMostrar = false;

    this.idAssinatura = this.$route.params.id;
    this.carregar();
  },
  beforeDestroy() {
    this.revogarVisualizacaoDocumento();
  },
  methods: {
    carregar() {
      return this.buscarAssinatura();
    },
    buscarAssinatura() {
      this.carregando = true;

      return pessoaFisicaServico
        .buscarAssinatura(this.idAssinatura)
        .then(dados => {
          this.assinatura = dados || {};
          this.carregando = false;

          return this.carregarVisualizacaoDocumento();
        })
        .catch(erro => {
          this.carregando = false;
          this.$mensagemErro(erro, 'Ocorreu um erro ao buscar os dados da assinatura.');
        });
    },
    carregarVisualizacaoDocumento() {
      if (!this.dadosDocumento.caminhoArquivoOriginal) {
        return Promise.resolve();
      }

      this.carregandoVisualizacao = true;
      this.revogarVisualizacaoDocumento();

      return pessoaFisicaServico
        .visualizarArquivoAssinatura(this.idAssinatura)
        .then(blob => {
          const urlFactory = window.URL || window.webkitURL;

          this.tipoVisualizacaoArquivo = blob.type || '';

          const urlBlob = urlFactory.createObjectURL(blob);
          this.visualizacaoArquivoUrl = urlBlob + '#toolbar=0&view=FitH';
        })
        .catch(() => { })
        .then(() => {
          this.carregandoVisualizacao = false;
        });
    },
    revogarVisualizacaoDocumento() {
      if (!this.visualizacaoArquivoUrl) {
        return;
      }

      const urlFactory = window.URL || window.webkitURL;
      urlFactory.revokeObjectURL(this.visualizacaoArquivoUrl);
      this.visualizacaoArquivoUrl = '';
    },
    downloadArquivoAssinatura() {
      return pessoaFisicaServico
        .downloadArquivoAssinatura(this.idAssinatura, this.nomeArquivoDownload)
        .then(arquivo => {
          arquivo.download();
        })
        .catch(erro => {
          this.$mensagemErro(erro, 'Ocorreu um erro ao baixar o documento.');
        });
    },
    assinarDocumento() {
      if (!this.podeAssinar || this.assinandoDocumento) {
        return Promise.resolve();
      }

      this.assinandoDocumento = true;

      return this.obterGeolocalizacaoAssinatura()
        .then(geolocalizacao => {
          return this.executarAssinatura(geolocalizacao);
        })
        .catch(erro => {
          if (erro && erro.tipo === 'geolocalizacao') {
            return this.oferecerAssinaturaSemGeolocalizacao(erro);
          }

          this.$mensagemErro(erro, 'Ocorreu um erro ao assinar o documento.');
        })
        .then(() => {
          this.assinandoDocumento = false;
        });
    },
    executarAssinatura(geolocalizacao = null) {
      return pessoaFisicaServico
        .assinarDocumento(this.idAssinatura, geolocalizacao)
        .then(() => {
          this.aceiteTermos = false;
          return this.buscarAssinatura();
        })
        .then(() => {
          return this.$swal({
            title: '',
            text: 'Documento assinado com sucesso.',
            type: 'success',
            allowOutsideClick: false,
            allowEscapeKey: false
          }).then(() => {
            this.verDetalhesDocumento(this.idAssinatura);
          });
        });
    },
    verDetalhesDocumento(idDocumentoAssinaturaAssinante) {
      this.$router.push({
        name: `${this.prefixoRota}.detalhes`,
        params: { id: idDocumentoAssinaturaAssinante },
      });
    },
    obterGeolocalizacaoAssinatura() {
      if (!window.navigator || !window.navigator.geolocation) {
        return Promise.reject(this.criarErroGeolocalizacao(
          'nao_suportado',
          'Seu navegador não oferece suporte a geolocalização. Não foi possível concluir a assinatura.'
        ));
      }

      return new Promise((resolve, reject) => {
        window.navigator.geolocation.getCurrentPosition(
          posicao => {
            resolve({
              latitude: posicao.coords.latitude,
              longitude: posicao.coords.longitude,
            });
          },
          erro => {
            if (erro.code === 1) {
              reject(this.criarErroGeolocalizacao(
                'permissao_negada',
                'Permita o acesso a sua localização para concluir a assinatura do documento.'
              ));
              return;
            }

            if (erro.code === 3) {
              reject(this.criarErroGeolocalizacao(
                'tempo_esgotado',
                'O tempo para obter sua localização expirou. Tente novamente.'
              ));
              return;
            }

            reject(this.criarErroGeolocalizacao(
              'indisponivel',
              'Não foi possível determinar sua localização no momento. Tente novamente.'
            ));
          },
          {
            enableHighAccuracy: true,
            timeout: 10000,
            maximumAge: 0,
          }
        );
      });
    },
    criarErroGeolocalizacao(codigo, mensagem) {
      return {
        tipo: 'geolocalizacao',
        codigo,
        mensagem,
      };
    },
    oferecerAssinaturaSemGeolocalizacao(erro) {
      const tipoMensagem = erro.codigo === 'permissao_negada' ? 'warning' : 'info';

      return new Promise((resolve, reject) => {
        this.$swal({
          title: '',
          text: `${erro.mensagem} Deseja continuar a assinatura sem localização?`,
          type: tipoMensagem,
          showCancelButton: true,
          confirmButtonText: 'Continuar sem localização',
          cancelButtonText: 'Voltar',
          allowOutsideClick: false,
          allowEscapeKey: false,
        })
          .then(() => {
            return this.executarAssinatura(null)
              .then(resolve)
              .catch(reject);
          }, dismiss => {
            if (dismiss === 'cancel') {
              resolve(false);
              return;
            }

            resolve(false);
          });
      });
    },
    voltar() {
      if (this.$route.query.origem === 'detalhes') {
        this.$router.push({
          name: `${this.prefixoRota}.detalhes`,
          params: { id: this.idAssinatura },
        });
        return;
      }

      this.$router.push({
        name: this.prefixoRota
      });
    },
    classeStatus(status) {
      if (status === 'AGUARDANDO') return 'label-primary';
      if (status === 'ASSINADO') return 'label-success';
      if (status === 'CONCLUIDO') return 'label-success';
      if (status === 'CANCELADO') return 'label-danger';

      return 'label-default';
    },
    formatarDataHora(data) {
      if (!data) {
        return '---';
      }

      const dataConvertida = new Date(data);

      if (Number.isNaN(dataConvertida.getTime())) {
        return '---';
      }

      const dataFormatada = dataConvertida.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      });
      const horaFormatada = dataConvertida.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });

      return `${dataFormatada} ${horaFormatada}`;
    },
    extrairExtensaoArquivo(caminhoArquivo) {
      if (!caminhoArquivo) {
        return '';
      }

      const indiceUltimoPonto = caminhoArquivo.lastIndexOf('.');

      if (indiceUltimoPonto === -1) {
        return '';
      }

      return caminhoArquivo.slice(indiceUltimoPonto);
    },
  },
  computed: {
    prefixoRota() {
      return (this.$route.meta && this.$route.meta.prefixoRotaAssinatura) || 'pessoa-fisica.assinatura';
    },
    dadosAssinante() {
      return this.assinatura || {};
    },
    dadosDocumento() {
      return this.assinatura.documentoAssinatura || {};
    },
    possuiAssinatura() {
      return !!this.assinatura.idDocumentoAssinaturaAssinante;
    },
    aguardandoAssinatura() {
      return this.dadosAssinante.statusAssinatura === 'AGUARDANDO';
    },
    podeAssinar() {
      return this.aguardandoAssinatura && this.aceiteTermos;
    },
    documentoEhPdf() {
      return this.tipoVisualizacaoArquivo.indexOf('pdf') !== -1 ||
        (this.dadosDocumento.caminhoArquivoOriginal || '').toLowerCase().slice(-4) === '.pdf';
    },
    nomeArquivoExibicao() {
      if (this.dadosDocumento.nomeArquivo) {
        return this.dadosDocumento.nomeArquivo;
      }

      const caminhoArquivo = this.dadosDocumento.caminhoArquivoOriginal || '';
      const partes = caminhoArquivo.split('\\');

      return partes[partes.length - 1] || 'Documento';
    },
    nomeArquivoDownload() {
      const nomeArquivo = this.nomeArquivoExibicao;

      if (nomeArquivo.indexOf('.') !== -1) {
        return nomeArquivo;
      }

      return `${nomeArquivo}${this.extrairExtensaoArquivo(this.dadosDocumento.caminhoArquivoOriginal)}`;
    },
    textoAceite() {
      return `Eu, ${this.dadosAssinante.nomeAssinante || '---'}, inscrito no CPF ${this.dadosAssinante.cpfAssinante || '---'}, declaro que li, compreendi e desejo assinar este documento eletronicamente.`;
    }
  }
}
</script>

<template>
  <div>
    <carregando v-if="carregando"></carregando>

    <div class="ibox float-e-margins" v-if="!carregando">
      <div class="ibox-content">
        <div class="row margin-bottom-10">
          <div class="col-sm-8">
            <h2><b>Assinatura eletronica</b></h2>
            <p class="text-muted no-margin-bottom">
              Revise o documento, leia os termos e conclua a assinatura.
            </p>
          </div>
          <div class="col-sm-4 text-right assinar-documento-topo-acoes">
            <button type="button" class="btn btn-white margin-right-10" @click="downloadArquivoAssinatura"
              :disabled="!possuiAssinatura">
              <i class="fa fa-download"></i>
              Baixar documento
            </button>
            <button type="button" class="btn btn-secundary" @click="voltar">
              <i class="fa fa-arrow-left"></i>
              Voltar
            </button>
          </div>
        </div>

        <div v-if="possuiAssinatura" class="assinar-documento-layout">
          <div class="assinar-documento-coluna-documento">
            <div class="assinar-documento-painel">
              <div class="assinar-documento-painel-cabecalho">
                <div class="row">
                  <div class="col-sm-8">
                    <h3 class="no-margin-top"><b>{{ nomeArquivoExibicao }}</b></h3>
                    <p class="text-muted no-margin-bottom">
                      {{ dadosDocumento.tipoDocumento || 'Tipo de documento nao informado.' }}
                    </p>
                  </div>
                  <div class="col-sm-4 text-right">
                    <span class="label" :class="classeStatus(dadosDocumento.statusDocumento)">
                      {{ dadosDocumento.statusDocumento || '---' }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="assinar-documento-painel-corpo assinar-documento-painel-corpo-preview">
                <div v-if="carregandoVisualizacao" class="assinar-documento-placeholder">
                  <i class="fa fa-spinner fa-pulse fa-2x"></i>
                  <p class="margin-top-10 no-margin-bottom">Carregando documento para visualizacao...</p>
                </div>

                <iframe v-else-if="visualizacaoArquivoUrl && documentoEhPdf" :src="visualizacaoArquivoUrl"
                  class="assinar-documento-preview" title="Visualizacao do documento a ser assinado">
                </iframe>

                <div v-else class="assinar-documento-placeholder">
                  <i class="fa fa-file-pdf-o fa-3x"></i>
                  <p class="margin-top-10 margin-bottom-5">
                    Não foi possivel exibir o documento nesta tela.
                  </p>
                  <p class="text-muted margin-bottom-10">
                    Baixe o arquivo para revisar o conteudo antes de seguir com a assinatura.
                  </p>
                  <button type="button" class="btn btn-white" @click="downloadArquivoAssinatura">
                    <i class="fa fa-download"></i>
                    Baixar documento
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="assinar-documento-coluna-lateral">
            <div class="assinar-documento-painel assinar-documento-termos">
              <div class="assinar-documento-painel-cabecalho">
                <h3 class="no-margin-top no-margin-bottom"><b>Termos da assinatura</b></h3>
              </div>

              <div class="assinar-documento-painel-corpo">
                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Assinante</dt>
                    <dd>{{ dadosAssinante.nomeAssinante || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>CPF</dt>
                    <dd>{{ dadosAssinante.cpfAssinante || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-6">
                    <dt>Papel</dt>
                    <dd>{{ dadosAssinante.papelAssinatura || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Status da assinatura</dt>
                    <dd>
                      <span class="label" :class="classeStatus(dadosAssinante.statusAssinatura)">
                        {{ dadosAssinante.statusAssinatura || '---' }}
                      </span>
                    </dd>
                  </dl>
                  <dl class="col-xs-6">
                    <dt>Data de envio</dt>
                    <dd>{{ formatarDataHora(dadosAssinante.dataHoraCriacao) }}</dd>
                  </dl>
                </div>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="bs-callout bs-callout-info assinar-documento-resumo">
                  <h4>Resumo do documento</h4>
                  <p class="margin-bottom-5"><b>Tipo:</b> {{ dadosDocumento.tipoDocumento || '---' }}</p>
                  <p class="margin-bottom-5"><b>Hash SHA-256:</b></p>
                  <p class="assinar-documento-hash no-margin-bottom">
                    {{ dadosDocumento.hashSHA256 || '---' }}
                  </p>
                </div>

                <p>
                  <b>Ao prosseguir com esta ação, declaro estar ciente e de acordo que:</b>
                </p>

                <p style="text-align: justify;">
                  <b> 1 - </b>Esta assinatura possui validade jurídica plena, nos termos da Lei nº 14.063/2020
                  (Assinaturas Eletrônicas) e do Art. 10, § 2º, da Medida Provisória nº 2.200-2/2001.
                </p>
                <p style="text-align: justify;">
                  <b> 2 - </b>Para garantir a segurança, integridade e autenticidade deste ato, o sistema coletará e
                  armazenará permanentemente os seguintes dados técnicos do meu dispositivo: Endereço IP, Data e Hora
                  exata do acesso, e dados do navegador/sistema operacional.
                </p>
                <p style="text-align: justify;">
                  <b> 3 - </b>O tratamento destes dados pessoais fundamenta-se no Art. 7º, incisos V e IX da Lei Geral
                  de Proteção de Dados (LGPD), sendo estritamente necessários para a execução de contrato e legítimo
                  interesse de segurança e auditoria, não sendo possível sua exclusão posterior.
                </p>

                <div v-if="dadosAssinante.motivoCancelamento || dadosDocumento.motivoCancelamento"
                  class="alert alert-warning no-margin-bottom">
                  <b>Motivo do cancelamento:</b>
                  {{ dadosAssinante.motivoCancelamento || dadosDocumento.motivoCancelamento }}
                </div>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="form-group no-margin-bottom" :class="{ 'text-muted': !aguardandoAssinatura }">
                  <div class="checkbox">
                    <label>
                      <input type="checkbox" class="custom-checkbox" v-model="aceiteTermos"
                        :disabled="!aguardandoAssinatura || assinandoDocumento">
                      {{ textoAceite }}
                    </label>
                  </div>
                </div>
                <div class="assinar-documento-painel-corpo assinar-documento-acao-corpo">
                  <button type="button" class="btn btn-primary btn-block" :disabled="!podeAssinar || assinandoDocumento"
                    @click="assinarDocumento">
                    <i class="fa" :class="assinandoDocumento ? 'fa-spinner fa-pulse' : 'fa-pencil'"></i>
                    {{ assinandoDocumento ? 'Obtendo localizacao...' : 'Assinar documento' }}
                  </button>

                  <p class="assinar-documento-acao-status no-margin-bottom">
                    <span v-if="aguardandoAssinatura && assinandoDocumento">
                      Coletando latitude e longitude para enviar junto com a assinatura.
                    </span>
                    <span v-else-if="aguardandoAssinatura">
                      {{ aceiteTermos ? 'Aceite realizado. Documento pronto para assinatura.' : 'Marque o aceite para liberar a assinatura.' }}
                    </span>
                    <span v-else>
                      Esta solicitação não esta mais disponível para assinatura.
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-else class="alert alert-warning no-margin-bottom">
          Nenhuma assinatura foi encontrada para o identificador informado.
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.assinar-documento-layout {
  display: flex;
  gap: 20px;
  min-height: 720px;
}

.assinar-documento-coluna-documento {
  flex: 0 0 70%;
  max-width: 70%;
}

.assinar-documento-coluna-lateral {
  flex: 0 0 30%;
  max-width: 30%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  height: 100%;
}

.assinar-documento-termos {
  flex: 0 0 70%;
  min-height: 0;
}

.assinar-documento-acao {
  flex: 0 0 30%;
}

.assinar-documento-painel {
  display: flex;
  flex-direction: column;
  height: 100%;
  border: 1px solid #e7eaec;
  background: #ffffff;
}

.assinar-documento-painel-cabecalho {
  padding: 15px 20px;
  border-bottom: 1px solid #e7eaec;
  background: #f8f8f9;
}

.assinar-documento-painel-corpo {
  padding: 20px;
  flex: 1;
  min-height: 0;
  overflow: auto;
}

.assinar-documento-painel-corpo-preview {
  padding: 0;
  background: #f3f3f4;
}

.assinar-documento-preview {
  width: 100%;
  height: 100vh;
  min-height: 640px;
  border: none;
  overflow: hidden;
  background: #f3f3f4;
}

.assinar-documento-placeholder {
  height: 100%;
  min-height: 640px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 30px;
  text-align: center;
  color: #676a6c;
}

.assinar-documento-resumo {
  margin-top: 20px;
  margin-bottom: 20px;
}

.assinar-documento-hash {
  word-break: break-all;
}

.custom-checkbox {
  width: 14px;
  height: 14px;
}

.assinar-documento-acao-corpo {
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.assinar-documento-acao-status {
  margin-top: 15px;
  color: #676a6c;
}

@media (max-width: 991px) {
  .assinar-documento-layout {
    flex-direction: column;
    min-height: auto;
  }

  .assinar-documento-coluna-documento,
  .assinar-documento-coluna-lateral {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .assinar-documento-preview,
  .assinar-documento-placeholder {
    min-height: 480px;
  }
}

@media (max-width: 767px) {
  .assinar-documento-topo-acoes {
    margin-top: 15px;
    text-align: left;
  }

  .assinar-documento-topo-acoes .btn {
    display: block;
    width: 100%;
    margin-right: 0;
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// FrontEnd/modulos/pessoa-fisica/componentes/AssinarDocumento.vue